export default "<h3 *ngIf=\"el.text != ''\">{{el.text}}</h3>\n<ul>\n\t<li *ngFor=\"let item of el.value\">\n\t\t{{item}}\n\t</li>\n</ul>\n";